var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-admin',[_c('admin-crop-grid',{attrs:{"title":_vm.title,"rows":_vm.data,"cols":_vm.cols,"row-href":_vm.rowHref,"defaultOrderBy":"id","defaultOrderByAscending":true},scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('div',[_c('ui-button',{staticClass:"flex items-center flex-shrink-0",on:{"click":function($event){return _vm.$bus.$emit('modal:open', {
						view: {
							view: 'views/Admin/SubscriptionCreate',
							data: { amount: 178.5, subscription_id: 1 }
						}
					})}}},[_c('ui-icon',{staticClass:"mr-2 -ml-1 flex-shrink-0 h-5 w-5 text-white",attrs:{"name":"plus","stroke-width":"2"}}),_vm._v(" "),_c('span',{},[_vm._v(_vm._s(_vm.__("New free subscription")))])],1)],1)]},proxy:true}])})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }